class SubscriptionWidget extends HTMLElement {
  constructor() {
    super();
    this.handleSellingPlanChange = this.handleSellingPlanChange.bind(this);
  }

  connectedCallback() {
    this.sellingPlanRadios = this.querySelectorAll('input[name="selling_plan"]');

    if (this.sellingPlanRadios.length) {
      this.sellingPlanRadios.forEach(radio => {
        radio.addEventListener('change', this.handleSellingPlanChange);
      });
    }
  }

  disconnectedCallback() {
    if (this.sellingPlanRadios) {
      this.sellingPlanRadios.forEach(radio => {
        radio.removeEventListener('change', this.handleSellingPlanChange);
      });
    }
  }

  handleSellingPlanChange(event) {
    const selectedRadio = event.target;
    const recurringValue = selectedRadio.dataset.recurring;

    if (!recurringValue) return;

    const hiddenInput = document.querySelector(`input[name="Recurring"][value="${recurringValue}"]`);
    if (hiddenInput) {
      hiddenInput.checked = true;
      hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

customElements.define('subscription-widget', SubscriptionWidget);